interface UserMenuModel {
  init: () => void;
  onMenuitemKeydown: (event: KeyboardEvent) => void;
  onButtonKeydown: (event: KeyboardEvent) => void;
  isOpen: () => boolean;
  openPopup: () => void;
  closePopup: () => void;
  setFocusToMenuitem: (item: HTMLElement) => void;
  handleClick: (event: Event) => void;
  setFocusToFirstMenuitem: () => void;
  setFocusToLastMenuitem: () => void;
  setFocusToPreviousMenuitem: (currentMenuitem: HTMLElement) => void;
  setFocusToNextMenuitem: (currentMenuitem: HTMLElement) => void;
  wrap?: HTMLElement | null;
  button?: HTMLElement | null;
  menu?: HTMLElement | null;
  menuItems?: NodeListOf<HTMLAnchorElement> | null;
  firstMenuitem?: HTMLElement;
  lastMenuitem?: HTMLElement;
  menuitemNodes?: HTMLElement[];
}

interface HTMLElement {
  onOutsideClick: (handler: (e: Event) => void, otherDependenceElement?: HTMLElement[]) => void;
}



HTMLElement.prototype.onOutsideClick =
  HTMLElement.prototype.onOutsideClick ||
  function (this: HTMLElement, handler: (e: MouseEvent | TouchEvent) => void, otherDependenceElement?: HTMLElement[]) {
    const listener = (event: MouseEvent | TouchEvent) => {
      // Do nothing if clicking ref's element or descendent elements
      if (!event.target || !this || this.contains(event.target as Node)) {
        return;
      }

      if (otherDependenceElement && otherDependenceElement.some((r) => r?.contains(event.target as Node))) {
        return;
      }

      handler(event);
    };

    document.addEventListener('mousedown', listener.bind(this));
    document.addEventListener('touchstart', listener.bind(this));
  };

(() => {
  const toggleMenu = (expandLink: HTMLElement, show: boolean) => {
    let ls: HTMLElement | null = expandLink.querySelector('ul');
    let ma: HTMLElement | null = expandLink.querySelector('.menuarrow');

    if (show) {
      expandLink.classList.add('showLinks');

      if (ls) {
        let lsh = ls.scrollHeight;
        ls.style.height = lsh + "px";
      }

      if (ma) {
        ma.style.transform = 'rotate(180deg)';
      }
    } else {
      expandLink.classList.remove('showLinks');

      if (ls) {
        ls.style.height = 0 + 'px';
      }

      if (ma) {
        ma.style.transform = 'rotate(0deg)';
      }
    }
  }

  const setExpandMenu = () => {
    const expandLinks = document.querySelectorAll('.expandLinks .menu-title');
    [].forEach.call(expandLinks, (exp: HTMLElement) => {
      exp.addEventListener('click', function (e: MouseEvent) {
        e.preventDefault();

        if (exp.closest('.expandLinks')?.classList.contains('showLinks')) {
          toggleMenu(exp.closest('.expandLinks') as HTMLElement, false);
          return;
        }

        // close all menu before expand
        [].forEach.call(expandLinks, (expandLink: HTMLElement) => toggleMenu(expandLink.closest('.expandLinks') as HTMLElement, false));

        // expand menu
        toggleMenu(exp.closest('.expandLinks') as HTMLElement, true);
      })
    });
  }

  const setToggleMobileNavigation = () => {
    const burger = document.querySelector('.burger');
    if (!burger) {
      return;
    }

    burger.addEventListener('click', (e) => {
      e.preventDefault();
      document.body.classList.toggle('open-mobile-navigation');
    });
  }

  /**
   * This function process data come from when storage area modified in the context of another document
   * For cart quantity modifier
   *    - we need to call window.localStorage.setItem('MSG_CART_QUANTITY', value)
   *    - And because the event isn't fire in the current context of the current document so we need to trigger the event manually by call window.dispatchEvent(new StorageEvent('storage', { key: 'MSG_CART_QUANTITY', oldValue: '0', newValue: quantity.toString() }));
   *        + Only key and newValue parameters are required
   *        + Because window.dispaychEvent invoke event synchronously so you should place it in asynchronously callback as setTimeout
   */
  const handleStoreModified = (event: StorageEvent) => {
    switch (event.key) {
      case 'MSG_CART_QUANTITY':
        const quantity = event.newValue;
        const headerCartQuantity = document.querySelectorAll('.header-cart-quantity');

        headerCartQuantity.forEach(item => {
          item!.textContent = `${quantity}`;
        })
        break;
      default:
        break;
    }
  };

  const setHeightHeaderTop = () => {
    const wrap = document.querySelectorAll<HTMLElement>('.header-wrapper');
    const headerTop = document?.querySelector('.header-top');

    if (headerTop) {
      [].forEach.call(wrap, (elem: HTMLElement) => {
        elem?.style.setProperty('--header-top-height', `${headerTop.scrollHeight}px`);
      });
    }
  };

  const initUserMenu: UserMenuModel = {
    wrap: document.querySelector<HTMLElement>('.header-top'),
    init() {
      const headerUser = this.wrap?.querySelector<HTMLElement>('.header-user');
      this.button = headerUser?.querySelector<HTMLAnchorElement>('#user-menu-parent');
      this.menu = headerUser?.querySelector<HTMLElement>('#user-menu-links');

      if (!this.button || !this.menu || !headerUser) {
        return;
      };

      this.menuItems = this.menu.querySelectorAll<HTMLAnchorElement>('li a');
      this.menuitemNodes = [];

      [].forEach.call(this.menuItems, (item: HTMLAnchorElement) => {
        item.addEventListener('keydown', this.onMenuitemKeydown.bind(this));
        this.menuitemNodes?.push(item);

        if (!this.firstMenuitem) {
          this.firstMenuitem = item;
        }

        this.lastMenuitem = item;
      });

      this.button.addEventListener('click', this.handleClick.bind(this));
      this.button.addEventListener('keydown', this.onButtonKeydown.bind(this));
      headerUser?.onOutsideClick(() => {
        this.closePopup();
      });
    },
    onMenuitemKeydown(event: KeyboardEvent) {
      const menuItem = event.currentTarget as HTMLAnchorElement;
      let flag = false;

      switch (event.key) {
        case ' ':
          window.location.href = menuItem.href;
          break;

        case 'Tab':
          this.closePopup();
          break;

        case 'Esc':
        case 'Escape':
          this.closePopup();
          this.button?.focus();
          flag = true;
          break;

        case 'Up':
        case 'ArrowUp':
          this.setFocusToPreviousMenuitem(menuItem);
          flag = true;
          break;

        case 'ArrowDown':
        case 'Down':
          this.setFocusToNextMenuitem(menuItem);
          flag = true;
          break;

        case 'Home':
        case 'PageUp':
          this.setFocusToFirstMenuitem();
          break;

        case 'End':
        case 'PageDown':
          this.setFocusToLastMenuitem();
          flag = true;
          break;

        default:
          break;
      }

      if (flag) {
        event.stopPropagation();
        event.preventDefault();
      }
    },
    isOpen() {
      return this.button?.getAttribute('aria-expanded') === 'true';
    },
    openPopup() {
      this.menu?.classList.add('open');
      this.button?.setAttribute('aria-expanded', 'true');
    },
    closePopup() {
      this.menu?.classList.remove('open');
      this.button?.setAttribute('aria-expanded', 'false');
    },
    setFocusToMenuitem(newMenuitem: HTMLElement) {
      [].forEach.call(this.menuItems, (item: HTMLElement) => {
        if (item === newMenuitem) {
          item.tabIndex = 0;
          newMenuitem.focus();
        } else {
          item.tabIndex = -1;
        }
      });
    },
    setFocusToFirstMenuitem() {
      this.firstMenuitem && this.setFocusToMenuitem(this.firstMenuitem);
    },
    handleClick(event: Event) {
      event.preventDefault();

      if (this.isOpen()) {
        this.closePopup();
      } else {
        this.openPopup();
      }
    },
    setFocusToPreviousMenuitem(currentMenuitem: HTMLElement) {
      var newMenuitem, index;

      if (currentMenuitem === this.firstMenuitem) {
        newMenuitem = this.lastMenuitem;
      } else {
        index = this.menuitemNodes?.indexOf(currentMenuitem);
        index !== -1 && index !== undefined && (newMenuitem = this.menuitemNodes?.at(index - 1));
      }

      newMenuitem && this.setFocusToMenuitem(newMenuitem);

      return newMenuitem;
    },
    setFocusToNextMenuitem(currentMenuitem: HTMLElement) {
      var newMenuitem, index;

      if (currentMenuitem === this.lastMenuitem) {
        newMenuitem = this.firstMenuitem;
      } else {
        index = this.menuitemNodes?.indexOf(currentMenuitem);
        index !== -1 && index !== undefined && (newMenuitem = this.menuitemNodes?.at(index + 1));
      }

      newMenuitem && this.setFocusToMenuitem(newMenuitem);

      return newMenuitem;
    },
    setFocusToLastMenuitem() {
      this.lastMenuitem && this.setFocusToMenuitem(this.lastMenuitem);
    },
    onButtonKeydown(event: KeyboardEvent) {
      let flag = false;

      switch (event.key) {
        case ' ':
        case 'Enter':
        case 'ArrowDown':
        case 'Down':
          this.openPopup();
          this.setFocusToFirstMenuitem();
          flag = true;
          break;

        case 'Esc':
        case 'Escape':
          this.closePopup();
          this.button?.focus();
          flag = true;
          break;

        case 'Up':
        case 'ArrowUp':
          this.openPopup();
          this.setFocusToLastMenuitem();
          flag = true;
          break;

        default:
          break;
      }

      if (flag) {
        event.stopPropagation();
        event.preventDefault();
      }
    }
  };



  // Listener storage event*
  window.addEventListener('storage', handleStoreModified);

  setHeightHeaderTop();
  setToggleMobileNavigation();
  setExpandMenu();
  initUserMenu.init();
})();